import EncryptedStorage from '$tablet-app/src/app/utils/encryptedStorage';

/** Locks the app as a given user */
export const setAppUnlocked = (): Promise<void> =>
  EncryptedStorage.removeItem(`app-locked`);
